/**
 *
 * Asynchronously loads the component for CorrectionApprovalsPage
 *
 */

import { lazyLoad } from "utils/loadable"

export const CorrectionApprovalsPage = lazyLoad(
  () => import("./index"),
  module => module.CorrectionApprovalsPage,
)
